import { Button } from '@mui/material';
import { Table } from '@tanstack/react-table';
import { L } from 'harmony-language';
import React from 'react';
import { QueryKeys } from '../../api/config';
import type { Load } from '../../types';
import { useBoolean } from '../shared/hooks/use-boolean';
import { DateFiltering } from '../shared/load-table/date-filtering';
import { DraftLoadFilterDrawer } from './draft-load-filter-drawer';
import { useDraftsLoadsContext } from './drafts-loads-context';
import { Presets2 } from './presets/presets2';
import { ArbitraryTextFilter } from './table-components/filters/arbitrary-text-filter';

interface LoadTableToolbarProps {
    draftsLoadsQueryRefetch: () => void;
    table: Table<Load>;
    resetTableState: () => void;
}

export const LoadTableToolbar: React.FC<LoadTableToolbarProps> = (props) => {
    const { draftsLoadsQueryRefetch, table, resetTableState } = props;
    const { isDrafts, globalIsDirty, resetSocketStopIds } = useDraftsLoadsContext();

    const [isDrawerOpen, openDrawer, closeDrawer] = useBoolean();

    const refetch = () => {
        resetSocketStopIds();
        draftsLoadsQueryRefetch();
    }

    return (
        <div className='lt-toolbar'>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                <DateFiltering
                    resetTableState={resetTableState}
                    tableKey={isDrafts ? QueryKeys.drafts : QueryKeys.loads}
                    refetch={refetch}
                    globalIsDirty={globalIsDirty}
                />
                <ArbitraryTextFilter table={table} />
                <Button variant='contained' onClick={openDrawer}>{L.filters()}</Button>
                <DraftLoadFilterDrawer
                    isDrawerOpen={isDrawerOpen}
                    closeDrawer={closeDrawer}
                    table={table}
                />
                <Presets2 table={table} />
            </div>
        </div>
    );
};
